<app-companies-nav [activeMenuItem]="'companies'"></app-companies-nav>
<mat-card class="content-card">
    <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <mat-card-title>
        </mat-card-title>
        <div fxFlex ></div>
        <a mat-raised-button color="primary" routerLink="add" *ngIf="deleteEnabled()" >Add company</a>
    </mat-card-header>
    <app-mat-table-generator #table
        tableName = "companiesTable"
        [columns] ="columns"
        [dataSource] ="dataSource"
        [viewLink]="getViewLink"
        [editLink]="getEditLink"
        [editEnabled]="editEnabled()"
        [deleteEnabled]="deleteEnabled()"
        [multiselectEnabled]="deleteEnabled()"
        >
    </app-mat-table-generator>
</mat-card>
